<template>
  <div class="wheel-of-life">

    <Instructions
        v-if="showInstructions"
        :showInstructions
        :workStarted
    :categories />

    <Interview
        v-if="!showInstructions && workStarted && !interviewComplete"
        :categories
    />

    <Chart
        v-if="interviewComplete"
        :categories
        :presentData
        :futureData />

<!--    <Chart-->
<!--        :categories-->
<!--        :presentData-->
<!--        :futureData />-->


  </div>

</template>

<script>
import pdfGenerator from "./pdfGenerator.vue";
import Chart from "./Chart.vue";
import Instructions from "./Instructions.vue";
import Interview from "./Interview.vue";

export default {
  components: {pdfGenerator, Instructions, Chart, Interview},

  data() {
    return {
      pdfContent:        "",
      showInstructions:  true,
      workStarted:       0,
      interviewComplete: false,
      categories:        [
        {label: "Career", desc: "Satisfaction with your current job, career progression, and work-life balance."},
        {label: "Finances", desc: "Management of your income, savings, and overall financial security."},
        {label: "Health", desc: "Physical well-being including diet, exercise, and mental health."},
        {label: "Relationships", desc: "Quality of your connections with friends and/or significant other."},
        {label: "Family", desc: "Satisfaction with your family dynamics and connections with loved ones."},
        {label: "Environment", desc: "Home or Office conditions."},
        {label: "Personal Growth", desc: "Commitment to learning, self-improvement, and achieving personal goals."},
        {label: "Spirituality", desc: "Connection to your inner self, higher purpose, or religious beliefs."},
        {label: "Recreation", desc: "Time spent on hobbies, relaxation, and enjoyable activities."},
      ],
      presentData:  [],
      futureData:  [],
    };
  },
}
</script>
